import script from "./footer-top.vue?vue&type=script&setup=true&lang=js"
export * from "./footer-top.vue?vue&type=script&setup=true&lang=js"

import "./footer-top.vue?vue&type=style&index=0&id=79c900c2&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/ciyc-web-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79c900c2"]])

export default __exports__